import { PlaySessionType } from '../types/PlaySession.type';

export function getMyTeam(teamCode: string, teams: PlaySessionType['teams']) {
  const team = teams.find((v) => v.code === teamCode);
  return team;
}
